import {
  useAllValidAnimals,
  useCurrentAnimal,
} from "components/Signup/store/selectors/animals";
import Router from "next/router";
import { parseUrl } from "../utils/parseUrlQuery";
import { sequentialAnimalRoutes } from "components/Signup/store/middlewares/utils/updateRoute";
import { StepName } from "components/Signup/steps/types";

export const useSequentialAnimals = () => {
  const animals = useAllValidAnimals();
  const animal = useCurrentAnimal();

  const { stepName } = parseUrl(Router.query);

  if (!sequentialAnimalRoutes.includes(stepName as StepName)) {
    return {
      currentAnimalIndex: null,
      nextAnimalId: null,
    };
  }

  const currentAnimalIndex = animals.findIndex((a) => a.id === animal.id);
  const nextAnimalId = animals[currentAnimalIndex + 1]?.id;

  return {
    currentAnimalIndex,
    nextAnimalId,
  };
};
